/**
 * Drawer Teleport
 * En MOBILE: Mueve el custom-menu-drawer al body para el drawer lateral
 * En DESKTOP: Lo mantiene dentro del header-quick-links__wrapper para el megamenu
 */

(function() {
  function teleportDrawer() {
    const drawer = document.querySelector('custom-menu-drawer');
    const isMobile = window.innerWidth < 990;
    
    if (!drawer) return;
    
    // Mobile: Mover al body para el drawer lateral
    if (isMobile && drawer.parentElement.tagName !== 'BODY') {
      console.log('[Drawer Teleport] Mobile - Moviendo drawer al body...');
      document.body.appendChild(drawer);
    }
    
    // Desktop: Mover de vuelta al wrapper si está en el body
    if (!isMobile && drawer.parentElement.tagName === 'BODY') {
      const wrapper = document.querySelector('.header-quick-links__wrapper');
      if (wrapper) {
        console.log('[Drawer Teleport] Desktop - Moviendo drawer al wrapper...');
        wrapper.appendChild(drawer);
      }
    }
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', teleportDrawer);
  } else {
    teleportDrawer();
  }
  
  // Re-evaluar en resize (con debounce)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(teleportDrawer, 150);
  });
  
  // También ejecutar en el theme editor cuando se carga/reordena
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(teleportDrawer, 100);
    });
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(teleportDrawer, 100);
    });
  }
})();

